import {
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
  MetaReducer
} from '@ngrx/store';
import { environment } from '../../environments/environment';
import * as fromCommons from '../reducer/commons.reducer';

export interface AppState {
  commons: fromCommons.CommonState;
}

export const reducers: ActionReducerMap<AppState> = {
  commons: fromCommons.reducer
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? []
  : [];
